import React from 'react';
import { createRoot } from 'react-dom/client';
import { IGlossaryIconModel } from '../glossary-icons-block/models/glossary-icons-block-models';
import GlossaryPageApp from './components/glossary-page-app';
import { IGlossaryContentBlockModel } from './models/glossary-page-models';

const entryDiv = document.getElementById('glossary-page-app');

if (entryDiv) {
    const root = createRoot(entryDiv);
    let glossaryContentItems = (window as any).glossaryPageBootstrap.glossaryContentItems as IGlossaryContentBlockModel[];
    let relatedSocialMediaIcons = (window as any).glossaryPageBootstrap.relatedSocialMediaIcons as IGlossaryIconModel[];
    let relatedSocialMediaPlatformsHeading = (window as any).glossaryPageBootstrap.relatedSocialMediaPlatformsHeading as string;
    let backCtaText = (window as any).glossaryPageBootstrap.backCtaText as string;
    let backCtaUrl = (window as any).glossaryPageBootstrap.backCtaUrl as string;
    let heading = (window as any).glossaryPageBootstrap.heading as string;

    let noSearchResultsText = (window as any).glossaryPageBootstrap.noSearchResultsText as string;
    let searchPlaceholderText = (window as any).glossaryPageBootstrap.searchPlaceholderText as string;
    let searchCtaText = (window as any).glossaryPageBootstrap.searchCtaText as string;
    let topicText = (window as any).glossaryPageBootstrap.topicText as string;
    let topicTextForMobile = (window as any).glossaryPageBootstrap.topicTextForMobile as string;

    root.render(
        <GlossaryPageApp
            glossaryContentItems={glossaryContentItems}
            relatedSocialMediaIcons={relatedSocialMediaIcons}
            relatedSocialMediaPlatformsHeading={relatedSocialMediaPlatformsHeading}
            backCtaText={backCtaText}
            backCtaUrl={backCtaUrl}
            noSearchResultsText={noSearchResultsText}
            searchPlaceholderText={searchPlaceholderText}
            searchCtaText={searchCtaText}
            heading={heading}
            topicText={topicText}
            topicTextForMobile={topicTextForMobile}
        />
    );
}